/*
 * Brochure-aanvraag rechtstreeks naar Klaviyo (Client API, publieke sleutel).
 * - Altijd: profiel + event "Brochure aangevraagd" (met systeem, pagina, taal, land).
 * - Alleen met aangevinkt toestemmingsvakje: aanmelden voor de lijst (marketing).
 * Het formulier zelf blijft gewoon naar Shopify posten; dit draait ernaast en mag
 * het versturen nooit blokkeren.
 */
var SF_KLAVIYO_REVISION = '2024-10-15';

function sfKlaviyoPost(path, company, payload) {
  try {
    fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(company), {
      method: 'POST',
      keepalive: true,
      headers: { 'Content-Type': 'application/vnd.api+json', 'revision': SF_KLAVIYO_REVISION },
      body: JSON.stringify(payload)
    }).catch(function () {});
  } catch (e) {}
}

function sfKlaviyoTrackBrochure(form) {
  var company = form.getAttribute('data-klaviyo-company');
  if (!company) return;
  var emailInput = form.querySelector('input[name="contact[email]"]');
  var nameInput = form.querySelector('input[name="contact[first_name]"]');
  var consentInput = form.querySelector('input[name="contact[accepts_marketing]"]');
  var tagsInput = form.querySelector('input[name="contact[tags]"]');
  var email = emailInput ? emailInput.value.trim() : '';
  if (!email) return;

  var firstName = nameInput ? nameInput.value.trim() : '';
  var consent = !!(consentInput && consentInput.checked);
  var system = '';
  if (tagsInput) {
    tagsInput.value.split(',').forEach(function (tag) {
      tag = tag.trim();
      if (tag.indexOf('brochure-') === 0 && tag !== 'brochure-lead') system = tag.replace('brochure-', '');
    });
  }
  var nowIso = new Date().toISOString();
  var language = document.documentElement.lang || '';
  var country = (window.Shopify && window.Shopify.country) || '';

  var profileAttributes = {
    email: email,
    properties: { brochure_systeem: system, brochure_laatst_aangevraagd: nowIso, brochure_taal: language }
  };
  if (firstName) profileAttributes.first_name = firstName;

  sfKlaviyoPost('events', company, {
    data: {
      type: 'event',
      attributes: {
        time: nowIso,
        properties: {
          Systeem: system,
          Pagina: window.location.pathname,
          Taal: language,
          Land: country,
          'Marketing-toestemming': consent,
          'Brochure-URL': form.getAttribute('data-brochure-url') || ''
        },
        metric: { data: { type: 'metric', attributes: { name: 'Brochure aangevraagd' } } },
        profile: { data: { type: 'profile', attributes: profileAttributes } }
      }
    }
  });

  var listId = form.getAttribute('data-klaviyo-list');
  if (consent && listId) {
    sfKlaviyoPost('subscriptions', company, {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Brochure formulier (' + (system || 'onbekend') + ')',
          profile: { data: { type: 'profile', attributes: profileAttributes } }
        },
        relationships: { list: { data: { type: 'list', id: listId } } }
      }
    });
  }
}

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-sf-brochure-form]').forEach(function (form) {
    var emailInput = form.querySelector('[data-sf-brochure-email]');
    var errorEl = form.querySelector('[data-sf-brochure-error]');
    if (emailInput && errorEl) {
      var validate = function () {
        var value = emailInput.value.trim();
        var looksValid = value === '' || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
        emailInput.classList.toggle('sf-input-invalid', !looksValid);
        errorEl.classList.toggle('is-visible', !looksValid);
        emailInput.setAttribute('aria-invalid', looksValid ? 'false' : 'true');
      };
      emailInput.addEventListener('blur', validate);
      emailInput.addEventListener('input', function () {
        if (emailInput.classList.contains('sf-input-invalid')) validate();
      });
    }

    form.addEventListener('submit', function () { sfKlaviyoTrackBrochure(form); });

    var downloadLink = form.querySelector('[data-sf-brochure-download]');
    var brochureUrl = form.getAttribute('data-brochure-url');
    if (downloadLink && brochureUrl) {
      window.open(brochureUrl, '_blank');
    }
  });
});
